import { render } from "./PanelGroup.vue?vue&type=template&id=38a73eed&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=ts"
export * from "./PanelGroup.vue?vue&type=script&lang=ts"

import "./PanelGroup.vue?vue&type=style&index=0&id=38a73eed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38a73eed"

export default script